import { render, staticRenderFns } from "./MathProblemResolver.vue?vue&type=template&id=4f55c786"
import script from "./MathProblemResolver.vue?vue&type=script&lang=js"
export * from "./MathProblemResolver.vue?vue&type=script&lang=js"
import style0 from "./MathProblemResolver.vue?vue&type=style&index=0&id=4f55c786&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports